<div class="agent-questions">
  @for (q of questions(); track $index; let i = $index) {
    <fieldset class="agent-question" [disabled]="disabled() || !!answers()">
      <legend class="agent-question-text">
        {{ q.question }}
        @if (!answers() && q.multiSelect) {
          <span class="agent-question-hint">{{ 'colimind.questions.multiSelect' | translate }}</span>
        }
      </legend>
      @if (!answers() && q.message) {
        <p class="agent-question-message">{{ q.message }}</p>
      }

      @if (answers(); as sent) {
        <p class="agent-question-answer">{{ sent[i] || ('colimind.questions.notAnswered' | translate) }}</p>
      } @else {
        @if (q.multiSelect) {
          @for (o of q.options; track o.value) {
            <mat-checkbox
              class="agent-question-option"
              [checked]="isChecked(i, o.label)"
              [disabled]="disabled()"
              (change)="toggle(i, o.label, $event.checked)">
              <span class="agent-question-option-label">{{ o.label }}</span>
              @if (o.description) {
                <span class="agent-question-option-description">{{ o.description }}</span>
              }
            </mat-checkbox>
          }
        } @else {
          <mat-radio-group [disabled]="disabled()">
            @for (o of q.options; track o.value) {
              <mat-radio-button
                class="agent-question-option"
                [value]="o.label"
                [checked]="isChecked(i, o.label)"
                (change)="choose(i, o.label)">
                <span class="agent-question-option-label">{{ o.label }}</span>
                @if (o.description) {
                  <span class="agent-question-option-description">{{ o.description }}</span>
                }
              </mat-radio-button>
            }
          </mat-radio-group>
        }

        @if (q.allowFreeform || q.options.length === 0) {
          <input
            type="text"
            class="agent-question-freetext"
            [disabled]="disabled()"
            [placeholder]="'colimind.questions.ownAnswer' | translate"
            [ngModel]="selections()[i]?.freeText ?? ''"
            (ngModelChange)="setFreeText(i, $event)"
            (keydown.enter)="submit()" />
        }
      }
    </fieldset>
  }

  @if (!answers()) {
    <div class="agent-questions-actions">
      <button mat-flat-button color="primary" type="button" [disabled]="disabled() || !complete()" (click)="submit()">
        {{ 'colimind.questions.send' | translate }}
      </button>
    </div>
  }
</div>
